/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_3_BInputs */

const en_mk_how_3_b = /** @type {(inputs: Mk_How_3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start an agent team for independent tasks that can run together`)
};

const id_mk_how_3_b = /** @type {(inputs: Mk_How_3_BInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai tim agent untuk tugas mandiri yang bisa berjalan bersamaan`)
};

/**
* | output |
* | --- |
* | "Start an agent team for independent tasks that can run together" |
*
* @param {Mk_How_3_BInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_3_b = /** @type {((inputs?: Mk_How_3_BInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_3_BInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_3_b(inputs)
	return en_mk_how_3_b(inputs)
});